import HttpError from './HttpError';

/**
 * The HTTP status of a failed request, or `undefined` if it never got a response. Reads
 * `HttpError` and the `{ res: { status } }` shape that axios-based request errors carry.
 */
export default function getHttpStatusCode(error: unknown): number | undefined {
  if (error instanceof HttpError) return error.statusCode;
  const status = (error as { res?: { status?: unknown } } | undefined)?.res?.status;
  return typeof status === 'number' ? status : undefined;
}
